
import './dashboard.css';
import { useState, useEffect } from 'react';

import Header from '../../components/Header';
import Title from '../../components/Title';
import { FiMessageSquare, FiPlus, FiSearch, FiEdit2 } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';

import firebase from '../../services/firebaseConnection';
import Modal from '../../components/Modal';

const listRef = firebase.firestore().collection('empresas').orderBy('created', 'asc');

export default function Dashboard(){
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [lastDocs, setLastDocs] = useState();

  const [showPostModal, setShowPostModal] = useState(false);
  const [detail, setDetail] = useState();

  useEffect(()=> {

    async function loadEmpresas(){
      await listRef.limit(10)
      .get()
      .then((snapshot) => {
        updateState(snapshot)
      })
      .catch((err)=>{
        console.log('Deu algum erro: ', err);
        setLoadingMore(false);
      })
  
      setLoading(false);
  
    }

    loadEmpresas();

    return () => {

    }
  }, []);



  async function updateState(snapshot){
    const isCollectionEmpty = snapshot.size === 0;

    if(!isCollectionEmpty){
      let lista = [];

      snapshot.forEach((doc)=>{
        lista.push({
          id: doc.id,
          nomeempresa: doc.data().nomeempresa,
          estadoempresa: doc.data().estadoempresa,
          textosimplesempresa: doc.data().textosimplesempresa,
          textocompletoempresa: doc.data().textocompletoempresa,
          linkfbempresa: doc.data().linkfbempresa,
          linkinstagramempresa: doc.data().linkinstagramempresa,
          linksiteempresa: doc.data().linksiteempresa,
          created: doc.data().created,
          createdFormated: format(doc.data().created.toDate(), 'dd/MM/yyyy')
        })
      })

      const lastDoc = snapshot.docs[snapshot.docs.length -1]; //Pegando o ultimo documento buscado
      
      setEmpresas(empresas => [...empresas, ...lista]);
      setLastDocs(lastDoc);

    }else{
      setIsEmpty(true);
    }

    setLoadingMore(false);

  }


  async function handleMore(){
    setLoadingMore(true);
    await listRef.startAfter(lastDocs).limit(5)
    .get()
    .then((snapshot)=>{
      updateState(snapshot)
    })
  }


  function togglePostModal(item){
    setShowPostModal(!showPostModal) //trocando de true pra false
    setDetail(item);
  }
 

  if(loading){
    return(
      <div>
        <Header/>

        <div className="content">
          <Title name="Empresas">
            <FiMessageSquare size={25} />
          </Title>  

          <div className="container dashboard">
            <span>Buscando empresas...</span>
          </div>

        </div>      
      </div>
    )
  }

  return(
    <div>
      <Header/>

      <div className="content">
        <Title name="Empresas">
          <FiMessageSquare size={25} />
        </Title>

        {empresas.length === 0 ? (
          <div className="container dashboard">
            <span>Nenhuma empresa registrada...</span>

            <Link to="/empresas" className="new">
              <FiPlus size={25} color="#FFF" />
              Nova Empresa
            </Link>
          </div>
        )  : (
          <>
            <Link to="/empresas" className="new">
              <FiPlus size={25} color="#FFF" />
              Nova Empresa
            </Link>

            <table>
              <thead>
                <tr>
                  <th scope="col">Empresa</th>

                  <th scope="col">Cadastrado em</th>
                  <th scope="col">#</th>
                </tr>
              </thead>
              <tbody>
                {empresas.map((item, index)=>{
                  return(
                    <tr key={index}>
                      <td data-label="Empresa">{item.nomeempresa}</td>
                      <td data-label="Cadastrado">{item.createdFormated}</td>
                      <td data-label="#">
                        <button className="action" style={{backgroundColor: '#3583f6' }} onClick={ () => togglePostModal(item) }>
                          <FiSearch color="#FFF" size={17} />
                        </button>
                        <Link className="action" style={{backgroundColor: '#F6a935' }} to={`/empresas/${item.id}`} >
                          <FiEdit2 color="#FFF" size={17} />
                        </Link>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            
            {loadingMore && <h3 style={{textAlign: 'center', marginTop: 15 }}>Buscando dados...</h3>}
            { !loadingMore && !isEmpty && <button className="btn-more" onClick={handleMore}>Buscar mais</button> }

          </>
        )}

      </div>

      {showPostModal && (
        <Modal
          conteudo={detail}
          close={togglePostModal}
        />
      )}

    </div>
  )
}